import React from 'react';
import { Link } from 'react-router-dom';

import './styles.css';


const Component = () => (
  <div className="header_main">
    <Link className="header_logo_container" to="/">
      <div className="header_logo" />
      <div className="header_baloo">
        baloo
      </div>
    </Link>
    <Link className="header_link" to="/contribute">
      contribute
    </Link>
  </div>
);

Component.displayName = "Header";

export default Component;



// WEBPACK FOOTER //
// ./src/components/Header/index.js